/**
 * Carbon for IBM Products runtime gates.
 *
 * The sample-derived shell uses the IBM Products Nav family. The package
 * requires explicit component readiness flags before first render.
 */
import { pkg } from '@carbon/ibm-products';

pkg.component.Nav = true;
pkg.component.NavItem = true;
pkg.component.NavList = true;
